/*
 * @Author: zhaoliang
 * @Date: 2023-04-26 14:33:29
 * @LastEditTime: 2026-02-12 18:01:31
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/components/BaseUi/LoadingModalwithText/index.js
 *
 */
import { createVNode, render, reactive } from 'vue';
import textLoadingModal from './index.vue';

const plugin = {
  install(app) {
    // 创建一个响应式状态对象来管理可见性
    const state = reactive({
      visible: false,
    });

    // 创建虚拟节点，将 visible 属性绑定到响应式状态
    const vm = createVNode(textLoadingModal, { visible: state.visible });
    const container = document.createElement('div');

    // 渲染虚拟节点到容器
    render(vm, container);

    // 将渲染后的 DOM 元素添加到 body
    if (container.firstElementChild) {
      document.body.appendChild(container.firstElementChild);
    }

    // 定义全局方法
    app.config.globalProperties.$textLoading = (visible = true) => {
      state.visible = visible;

      // 更新组件的 visible prop (虽然 reactive 应该自动处理，但为了确保 VNode 更新，我们可以重新渲染)
      // 注意：在 Vue 3 中，直接修改 reactive 对象通常足以触发组件更新，
      // 但对于手动挂载的 VNode，我们需要确保 props 更新能传递进去。
      // 上面的 createVNode 绑定了 state.visible，所以修改 state.visible 应该能触发更新。
      // 但是，createVNode 创建的是一个快照。我们需要更稳健的方式。

      // 更好的方式是重新调用 createVNode 和 render
      const newVm = createVNode(textLoadingModal, { visible: state.visible });
      render(newVm, container);
    };

    app.config.globalProperties.$getTextLoadingStatus = () => {
      return state.visible;
    };
  },
};

export default plugin;

export { textLoadingModal };
